import { render, staticRenderFns } from "./ModifyPassWordModal.vue?vue&type=template&id=8c332504&"
import script from "./ModifyPassWordModal.vue?vue&type=script&lang=js&"
export * from "./ModifyPassWordModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassWordModal.vue?vue&type=style&index=0&id=8c332504&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports